import { createContext, useContext } from "react";

type OnboardingContextType = {
  openOnboarding: (token: string) => void;
  closeOnboarding: () => void;
};

export type LoginAfterRegistration = (email: string, password: string) => Promise<boolean>;

export const OnboardingOverlayContext = createContext<OnboardingContextType | null>(null);

export const useOnboardingOverlay = () => {
  const context = useContext(OnboardingOverlayContext);

  if (!context) {
    throw new Error("useOnboardingOverlay must be used inside OnboardingOverlayProvider");
  }

  return context;
};
